module.exports = __webpack_public_path__ + "img/fonetti.967dccd7.png";